import LanguageStrings from '../../../../../i18n/locales'

export const getCreationTimeline = (step: 0 | 1): JSX.Element => {
  const CreateGroupComponentStrings =
    LanguageStrings().AssetGroupStrings.CreateGroupComponent
  const fontSizes = function (): number[] {
    // returns [fontSize, x1, x2]
    const language = navigator.language
    if (language.startsWith('en')) {
      return [16, 20, 315]
    } else if (language.startsWith('es')) {
      return [16, 20, 315]
    } else if (language.startsWith('fr')) {
      return [16, 20, 315]
    } else if (language.startsWith('de')) {
      return [14, -30, 315]
    } else if (language.startsWith('ru')) {
      return [16, 20, 315]
    } else {
      return [16, 20, 315]
    }
  }

  if (step === 0) {
    return (
      <svg
        width="550"
        height="58"
        viewBox="0 0 476 58"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <line
          x1="132"
          y1="16"
          x2="363"
          y2="16"
          stroke="#4DBC48"
          strokeWidth="2"
        />
        <g filter="url(#filter0_d_11927_118517)">
          <circle cx="116" cy="16" r="12" fill="#4DBC48" />
          <rect x="110" y="10" width="12" height="12" rx="6" fill="#303030" />
        </g>
        <text
          x={fontSizes()[1].toString()}
          y="48"
          fill="white"
          fontSize={fontSizes()[0].toString()}
        >
          {CreateGroupComponentStrings.EnterGroupInformation}
        </text>
        <rect x="370" y="10" width="12" height="12" rx="6" fill="#909090" />
        <text
          x={fontSizes()[2].toString()}
          y="48"
          fill="white"
          fontSize={fontSizes()[0].toString()}
        >
          {CreateGroupComponentStrings.SelectAsset}
        </text>
        <defs>
          <filter
            id="filter0_d_11927_118517"
            x="100"
            y="0"
            width="40"
            height="40"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="4" dy="4" />
            <feGaussianBlur stdDeviation="4" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_11927_118517"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_11927_118517"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    )
  } else {
    return (
      <svg
        width="550"
        height="58"
        viewBox="0 0 476 58"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <line
          x1="132"
          y1="16"
          x2="352"
          y2="16"
          stroke="#4DBC48"
          strokeWidth="2"
        />
        <circle cx="116" cy="16" r="12" fill="#4DBC48" />
        <path
          d="M123 11L113.375 21L109 16.4545"
          stroke="#303030"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <text
          x={fontSizes()[1].toString()}
          y="48"
          fill="white"
          fontSize={fontSizes()[0].toString()}
        >
          {CreateGroupComponentStrings.EnterGroupInformation}
        </text>
        <g filter="url(#filter0_d_11929_118553)">
          <circle cx="370" cy="16" r="12" fill="#4DBC48" />
          <rect x="364" y="10" width="12" height="12" rx="6" fill="#303030" />
        </g>
        <text
          x={fontSizes()[2].toString()}
          y="48"
          fill="white"
          fontSize={fontSizes()[0].toString()}
        >
          {CreateGroupComponentStrings.SelectAsset}
        </text>
        <defs>
          <filter
            id="filter0_d_11929_118553"
            x="344"
            y="0"
            width="40"
            height="40"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="4" dy="4" />
            <feGaussianBlur stdDeviation="4" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_11929_118553"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_11929_118553"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    )
  }
}
